// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pYO8","left":"styles_left__1ncku","desktopActions":"styles_desktopActions__1vhRo","title":"styles_title__2iBAI"};